import React, { useEffect } from "react";
import { projectsInfo } from "../../assets/data/projects";
import { Project } from "./project";
import desk from "../../assets/images/projects.jpg";
import Fade from "react-reveal/Fade";
import { Banner } from "../../components/banner/index"
import './style.css'

export const Projects = () => {
  useEffect(() => {
    document.title = "Projects - Portfolio AV";
  }, []);

  const showProjects = () => {
    return (
      <div className="ProjectsGrid">
        {projectsInfo.map((item) => {
          return <Project key={item.id} project={item} />;
        })}
      </div>
    );
  };

  const showLatestProject = () => {
    return (
      <div className="ProjectHighlightBoxColor">
        <div className="Container">
          <div className="ProjectHighlightBox">
            <div className="ProjectHighlightBox_Title"> Recent project</div>
            <div className="ProjectHighlightBox_Project">
              <Project
                key={projectsInfo[projectsInfo.length - 1].id}
                project={projectsInfo[projectsInfo.length - 1]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Banner image={desk} text="Projects" />
      {showLatestProject()}
      <div className="Container">
        <Fade bottom>{showProjects()}</Fade>
      </div>
    </div>
  );
};
